import React from "react"
import PropTypes from "prop-types"
import tw from "twin.macro"

import Header from "./header"
import Footer from "./footer"

const Main = tw.main`container px-4 mx-auto flex-1 my-8`
const LayoutContainer = tw.div`font-body text-gray-800 flex flex-col min-h-screen`

export const PageTitle = tw.h1`text-4xl text-ql-blue mb-4`
export const SectionTitle = tw.h2`text-ql-blue font-bold mt-4 tracking-wide`
export const SubSectionTitle = tw.h3`font-bold mt-4 tracking-wide`
export const Leading = tw.p`text-base md:text-lg lg:text-xl tracking-wide leading-tight py-4`
export const Paragraph = tw.p`py-2`
export const Strong = tw.strong`font-bold`
export const BulletList = tw.ul`list-disc ml-4`
export const BulletListItem = tw.li``
export const Table = tw.table`table-auto`
export const TableHead = tw.thead`bg-gray-200`
export const TableBody = tw.tbody``
export const TableRow = tw.tr``
export const TableCell = tw.td`border px-4 py-2`
export const TableHeading = tw.th`border px-4 py-2`

const Layout = ({ Hero, Foundation, children }) => {

  return (
    <LayoutContainer>
      <Header/>
      {!!Hero && <Hero />}
      <Main>{children}</Main>
      {!!Foundation && <Foundation />}
      <Footer />
    </LayoutContainer>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  Hero: PropTypes.elementType,
  Foundation: PropTypes.elementType
}

export default Layout
